import axios from 'axios';

export const logoff = (contactId: string) => axios.post(
    `${global?.AppConfig?.SERVICES_URL_SUFFIX}/v1.0/contacts/${contactId}/authentication/logoff`,
);
